angular.module('picmonicng').directive('removeCard', [
  'PlaylistService',
  function (PlaylistService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('click', function () {
          scope.$apply(function () {
            PlaylistService.removeCard(scope.card.id);
          });
        });
      },
    };
  },
]);
